import { useState } from "react";
import { Input, type InputProps } from "./Input";

/** Password field with a show/hide toggle. */
export function PasswordInput(props: InputProps) {
  const [visible, setVisible] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <Input {...props} type={visible ? "text" : "password"} style={{ paddingRight: 44, ...props.style }} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          border: "none",
          background: "transparent",
          color: "var(--color-text-muted)",
          fontSize: "var(--font-size-xs)",
          cursor: "pointer",
          padding: "var(--space-1) var(--space-2)",
        }}
      >
        {visible ? "Hide" : "Show"}
      </button>
    </div>
  );
}
